<div class="not-found-page">


  <h1 class=""> {{'pageNotFound'|translate}} </h1>
  <h1 class=""> 404 </h1>

</div>
